import { useEffect } from 'react';

const useOnClickOutside = (
  ref: React.RefObject<HTMLElement>,
  onClick: () => void,
) => {
  const callback = (e: MouseEvent | TouchEvent) => {
    const target = e.target as HTMLElement;
    if (ref.current?.contains(target)) return;

    onClick();
  };

  useEffect(() => {
    document.addEventListener('mouseup', callback);
    document.addEventListener('touchend', callback);

    return () => {
      document.removeEventListener('mouseup', callback);
      document.removeEventListener('touchend', callback);
    };
  }, []);
};

export default useOnClickOutside;
